export const InvoiceState = [
    {
        name: "Completed Jobs",
        id: 0
    },
    {
        name: "Submitted Invoices",
        id: 1
    },
    {
        name: "Sent Invoices",
        id: 2
    },
    {
        name: "Paid Invoices",
        id: 3
    },
    {
        name: "Overdue Invoices",
        id: 4
    }
];

export const ArrState = [
    {
        name: 'Ready To Post',
        id: 0
    },
    {
        name: 'Authorisation Required',
        id: 1
    },
    {
        name: 'Sent To Xero',
        id: 2
    },
    {
        name: 'Paid',
        id: 3
    }
];